import { render, staticRenderFns } from "./PopupPaymentSuccess.vue?vue&type=template&id=4576f07f"
import script from "./PopupPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PopupPaymentSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports